import type {ProjectId} from '../../../../types'
import {ROOT_PROJECT_ID, stringifyId} from '../../../../types'
import type {TestOccurrencesTreeNode} from '../Tests.types'

export const getTestsLocator = ({
  baseLocator,
  projectId,
  currentlyFailing,
}: {
  baseLocator?: string
  projectId?: ProjectId
  currentlyFailing?: boolean
}): string => {
  const projectLocator =
    projectId != null ? `affectedProject:${stringifyId(projectId)},currentlyInvestigated:true` : ''
  const currentlyFailingLocator = currentlyFailing ? 'currentlyFailing:true' : ''
  return [baseLocator, projectLocator, currentlyFailingLocator].filter(Boolean).join(',')
}
export const getRootTestCounters = (
  nodes: ReadonlyArray<TestOccurrencesTreeNode> | undefined | null,
) => nodes?.find(node => node.name === ROOT_PROJECT_ID)?.testCounters

const isBuildScopedTestOccurrence = (id: string): boolean => id.startsWith('build:')

export const filterCheckedStateByBuild = (checkedState: readonly string[]): string[] => {
  const hasBuildScopedSelection = checkedState.some(isBuildScopedTestOccurrence)

  if (hasBuildScopedSelection) {
    return checkedState.filter(isBuildScopedTestOccurrence)
  }

  return checkedState.slice()
}
